<template>
    <div class="controls">
        <button class="controls__btn controls__action controls__decrement" :disabled="decrementDisabled" @click="decrement">−</button>
        <input
                class="controls__btn controls__field"
                type="number"
                :disabled="true"
                :min="min"
                :max="max"
                :step="step"
                v-model.number="currentValue"
                @blur="keyDownHandler"
                @keydown.esc="keyDownHandler"
                @keydown.enter="keyDownHandler"
                @keydown.up.prevent="increment"
                @keydown.down.prevent="decrement"

        />
        <button class="controls__btn controls__action controls__increment" :disabled="incrementDisabled" @click="increment">+</button>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: Boolean,
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            },
            value: {
                required: true,
                type: Number
            },
            step: {
                type: Number,
                default: 1
            },
            id: {
                type: Number,
                default: 1
            },
            circle: {
                type: Object,
            }
        },

        data() {
            return {
                currentValue: this.value,
                decrementDisabled: false,
                incrementDisabled: false,
                inputDisabled: false,
            }
        },

        watch: {
            value(val) {
                this.currentValue = val
            }
        },

        methods: {
            keyDownHandler() {
                this.currentValue = this.value
            },
            increment() {
                if (this.disabled || this.incrementDisabled) {
                    return
                }

                let newVal = this.currentValue + 1 * this.step
                this.decrementDisabled = false

                this._updateValue(newVal)
            },
            decrement() {
                if (this.disabled || this.decrementDisabled) {
                    return
                }

                let newVal = this.currentValue + -1 * this.step
                this.incrementDisabled = false

                this._updateValue(newVal)
            },
            _updateValue(newVal) {
                const oldVal = this.currentValue

                if (oldVal === newVal || typeof this.value !== 'number') {
                    return
                }
                if (newVal <= this.min) {
                    newVal = this.min
                    this.decrementDisabled = true
                }
                if (newVal >= this.max) {
                    newVal = this.max
                    this.incrementDisabled = true
                }
                this.currentValue = newVal
                this.updateLocation(newVal)

//                this.$emit('input', this.currentValue)
            },
            async updateLocation(radius) {
                let Circle = {
                    "center_latitude": this.circle.center_latitude,
                    "center_longitude": this.circle.center_longitude,
                    radius
                };
                this.$emit('saveCircleData', Circle)
                this.$store.dispatch('SET_DRAWING_CIRCLE_RADIUS', radius)
                try {
                    await this.$store.dispatch('FETCH_DRAWING_CIRCLE_DATA', {circle: Circle})
                } catch(e) {
                    console.log(e, 'e response')
                }
            },
        },
        mounted() {
            if (this.value == this.min) {
                this.decrementDisabled = true
            }
            if(this.value == this.max) {
                this.incrementDisabled = true
            }
        }
    }
</script>

